import { useCallback, useMemo, useState } from 'react';

import { useBreakPoints } from 'core';
import { PurchasesSearch, useListUserPurchases } from 'store/Api';
import { OneToTwoLayoutTemplate } from 'ui';

import { UserPurchasesSearchProvider } from './PurchaseSearchContext';
import { ExportPurchasesModalButton } from './components/ExportPurchasesModal';
import { PurchasesContent } from './components/PurchasesList';

const BASE_STORE_SEARCH: PurchasesSearch = {
  searches: {},
  join: 'AND',
};

const PurchasesPage = () => {
  const { isSmallScreen } = useBreakPoints();
  const [purchaseSearchObject, setPurchaseSearchObject] =
    useState<PurchasesSearch>(BASE_STORE_SEARCH);

  const _setPurchaseSearchObject = useCallback(
    (value: PurchasesSearch) => {
      setPurchaseSearchObject(value);
    },
    [setPurchaseSearchObject]
  );

  const { data, isInitialLoading } = useListUserPurchases({
    queryOptions: { ...purchaseSearchObject, join: 'AND' },
  });

  const isSearching = useMemo(() => {
    if (!purchaseSearchObject?.searches) {
      return false;
    }
    return Object.values(purchaseSearchObject?.searches).some((search) => search.value);
  }, [purchaseSearchObject?.searches]);

  const isDataEmpty = useMemo(() => {
    return !data?.pages[0].cart_items.length;
  }, [data?.pages]);

  const isPurchasesEmpty = useMemo(() => !isSearching && isDataEmpty, [isDataEmpty, isSearching]);

  const showExport = !isPurchasesEmpty && !isInitialLoading && isSmallScreen;

  return (
    <UserPurchasesSearchProvider
      value={{
        UserPurchasesSearchObject: purchaseSearchObject,
        setUserPurchasesSearchObject: _setPurchaseSearchObject,
      }}
    >
      <OneToTwoLayoutTemplate
        rightSection={<PurchasesContent isPurchasesEmpty={isPurchasesEmpty} />}
        mobileBottomButton={showExport && <ExportPurchasesModalButton />}
        showLeftSection={false}
      />
    </UserPurchasesSearchProvider>
  );
};

export { PurchasesPage };
